<template>
  <div class="side-content clearfix">
    <div class="side-left">
      <ul class="left-menu">
        <li @mouseenter="evtSideEnter(index);"
            v-for="(item,index) in serviceItems" :key="item.id"
            :class="(currActiveIndex === index ? 'activeSide':'')">
          <div class="tittle">
            <i :class="'iconfont '+ item.icon"></i>
            <span>{{item.name}}</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="desc">{{item.description}}</div>
        </li>
      </ul>
    </div>
    <div class="side-center-right" style="border-left: solid 1px #e0e0e0;">
      <div v-loading="loading">
        <table class="service-table" width="100%">
          <tbody>
          <tr v-for="serviceType in serviceTypes" :key="serviceType.code">
            <td width="80" class="service-type">
              <span>{{serviceType.name}}</span>
            </td>
            <td class="service">
             <span v-for="(service) in serviceType.services" :key="service.id">
               <a :href="'/service/detail?sid='+ service.id" :title="service.title" >
                 {{service.title}}
               </a>
             </span>
            </td>
          </tr>
          </tbody>
        </table>
        <ul class="service-li">
          <li v-for="(service) in services" :key="service.id">
            <a :href="'/service/detail?sid='+ service.id">
              {{service.title}}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getLists } from '@/api/test/testContent'

export default {
  name: 'ServiceMenu',
  data: function () {
    return {
      serviceTypes: [],
      services: [],
      currActiveIndex: 0,
      loading: false,
      serviceItems: this.commonUtils.getDictPara('service_type')
    }
  },
  mounted () {
    this.serviceItems.forEach(item => {
      let newName = item.name
      if (newName.split('_').length === 2) {
        item.icon = newName.split('_')[0]
        item.name = newName.split('_')[1]
      }
      item.serviceTypes = this.commonUtils.getDictPara(item.code + '_type')
    })
    this.getLists()
  },
  computed: {},
  methods: {
    getLists () {
      let param = {}
      this.loading = true
      getLists(param).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          let dataList = result.bizData
          // 数据封装
          this.serviceItems.forEach(item => {
            if (item.serviceTypes) {
              item.serviceTypes.forEach(sType => {
                sType.services = dataList.filter(ret => {
                  return (ret.infoId === item.code && ret.testType === sType.code)
                })
              })
            } else {
              item.services = dataList.filter(ret => {
                return (ret.infoId === item.code)
              })
            }
            this.evtSideEnter(0)
          })
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    evtSideEnter (index) {
      this.serviceTypes = this.serviceItems[index].serviceTypes
      this.services = this.serviceItems[index].services
      this.currActiveIndex = index
    },
    hideMenu () {
      this.currActiveIndex = -1
    }
  }
}
</script>

<style lang="scss" scoped>

  .side-content {
    width: 1060px;
    display: inline-flex;
    background: #FFFFFF;
    .side-left {
      width: 260px;
      height: 100%;
    }
    .side-center-right {
      width: 800px;
    }
  }

  .left-menu {
    margin: 0;
    padding: 0;
    li {
      padding: 7px 15px;
      border-bottom: solid 1px #e0e0e0;
      list-style: none;
      cursor: pointer;
      color: #3E3E3E;;
      background: #ffffff;
      cursor: pointer;
      .tittle {
        font-size: 15px;
        font-weight: bold;
        .iconfont {
          color: #32A08C;
          margin-right: 11px;
        }
        .el-icon-arrow-right {
          color: #32A08C;
          float: right;
        }
      }
      .desc {
        margin-top: 8px;
        font-size: 13px;
      }
    }
  }

  .service-table {
    width: 100%;
    padding-top: 10px;
    .service-type {
      vertical-align: middle;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      border-right: solid 1px #F2F6FC;
      border-bottom: solid 1px #F2F6FC;
      span{
        line-height: 36px;
      }
    }
    .service {
      border-bottom: solid 1px #F2F6FC;
      min-height: 60px;
      span {
        display: inline-block;
        width: 140px;
        font-size: 14px;
        color: #303133;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 36px;
        a {
          font-size: 14px;
          color: #303133;
          text-decoration: none;
          padding: 0 6px;
          line-height: 36px;
          &:hover {
            font-weight: bold;
          }
        }
      }
    }
  }

  .activeSide {
    color: #ffffff !important;
    background: #27c2b4!important;
    .iconfont {
      color: #ffffff !important;
    }
    .el-icon-arrow-right {
      color: #ffffff !important;
    }
  }
</style>
